import { Link, Navigate } from 'react-router';
import { useAuth } from '@/shared/AuthContext';

export function WelcomePage(): React.JSX.Element {
  // Item #6: il gate non legge piu' il token da localStorage (in cookie mode
  // l'access vive in memoria). Usa lo stato `user` di AuthContext, popolato
  // dal silent-refresh al boot. Finche' `booting` e' true mostriamo uno
  // spinner per non far lampeggiare la WelcomePage prima del refresh.
  const { user, booting } = useAuth();
  if (booting) {
    return <div className="spinner-overlay" />;
  }
  // Se ho gia' una sessione (utente loggato, o wrapper nativo che ha
  // rehydratato la sessione al boot), salta WelcomePage e vai in dashboard.
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <div className="login-shell">
      <div className="login-container">
        <div className="login-logo">
          <img src="/icon-128.webp" alt="VVF"
            style={{ width: 80, height: 80, margin: '0 auto 10px', display: 'block' }} />
          <h1>VVF Tracker</h1>
          <p>Distaccamento VVF Frassinoro/Pievepelago</p>
        </div>
        <h2 style={{ textAlign: 'center', color: '#333', marginBottom: 30, fontSize: 22 }}>
          Benvenuto
        </h2>
        <div className="welcome-buttons">
          <Link to="/hydrants-public" className="welcome-btn btn-map">
            🗺️ Mappa Idranti Pubblica
          </Link>
          <Link to="/login" className="welcome-btn btn-login">
            🔐 Accedi
          </Link>
        </div>
        <div className="form-footer" style={{ marginTop: 30 }}>
          <Link to="/register">Non hai un account? Registrati</Link>
        </div>
        {/* Link discreto alla privacy policy (richiesto da Play Store; volutamente
            poco visibile, in fondo e in grigio chiaro). */}
        <div style={{ textAlign: 'center', marginTop: 18 }}>
          <Link to="/privacy"
            style={{ fontSize: 11, color: '#b0b0b0', textDecoration: 'none' }}>
            Norme sulla privacy
          </Link>
        </div>
      </div>
    </div>
  );
}
